var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',_vm._g(_vm._b({class:['de-tabs' ].concat( _vm.tabClassName),style:(_vm.tabStyle)},'el-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }